var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('div',{staticClass:"bottom-text"},[_vm._v(_vm._s(_vm.textLine1)+" "),_c('a',{staticStyle:{"cursor":"pointer","color":"#ffffff"},attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("京ICP备15009692号-1")])]),_c('div',{staticClass:"bottom-text"},[_vm._v(_vm._s(_vm.textLine2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }